/**
 * Marca e documento do aceite no serviço de políticas da Primum — **os mesmos
 * do `enamed-feedback-lp`**: as LPs são da marca Aristo e a política é a
 * mesma. A rota é `POST {policies}/api/terms/{brand}/{document}/accept-latest/`;
 * "latest" porque quem resolve a versão vigente é o serviço, não o front.
 *
 * Par humano de `PRIVACY_POLICY_URL` (`auth.entity.ts`): se um mudar, o outro
 * muda junto, ou o aceite registrado deixa de ser o texto que foi lido.
 */
export const TERMS_BRAND = 'ARISTO';
export const TERMS_DOCUMENT = 'politicas_de_privacidade';

/**
 * O que vai para o registro do aceite. O nome inteiro, num campo só, como o
 * serviço de políticas guarda.
 */
export interface SignUpLead {
  email: string;
  fullName: string;
  phone: string;
}
